import React from "react";

import { H4 } from "../../atoms/Texts";
import { NewFormFooter } from "../../organisms/Footers";
import { FormProvider, useForm } from "react-hook-form";
import FormGenerator from "../../molecules/ModernFormBuilder/FormGenerator";

export const FormPreview = ({ changeStep, discard, fields, submitForm }) => {
  const { formFields } = fields;

  const formCtx = useForm({
    mode: "onChange",
  });

  return (
    <div className="flex-grow">
      <FormProvider {...formCtx}>
        <div className="px-10 pb-20">
          <H4 className="mt-10 mb-14">{fields?.service?.label}</H4>

          <section className="bg-white my-10  pt-16 pb-24 px-20 border rounded flex flex-col gap-y-4">
            <FormGenerator fields={formFields} />
          </section>
        </div>
        <NewFormFooter
          back={() => changeStep(2)}
          changeStep={submitForm}
          discard={discard}
        />
      </FormProvider>
    </div>
  );
};
